import { SUPPORTED_LOCALES, coerceLocale, type Locale } from "@/i18n/locales";

const DEFAULT_LOCALE: Locale = "en";

export function getLocaleFromPathname(pathname: string | null | undefined): Locale {
  if (!pathname) return DEFAULT_LOCALE;
  const firstSegment = pathname.split("/").filter(Boolean)[0];
  return coerceLocale(firstSegment);
}

export function withLocalePath(locale: Locale, path: string): string {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  const segments = normalizedPath.split("/").filter(Boolean);

  if (segments.length === 0) {
    return `/${locale}`;
  }

  if (SUPPORTED_LOCALES.includes(segments[0] as Locale)) {
    return normalizedPath;
  }

  return `/${locale}${normalizedPath}`;
}

export function withLocalizedQuery(
  locale: Locale,
  path: string,
  query?: Record<string, string | undefined | null>,
): string {
  const basePath = withLocalePath(locale, path);
  if (!query) return basePath;

  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (typeof value === "string" && value.length > 0) {
      params.set(key, value);
    }
  });

  const qs = params.toString();
  return qs ? `${basePath}?${qs}` : basePath;
}
